import { RESOURCE_TO_ROLE_MAP } from '@contexts/User/roles';
import { BellIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';
import { IApiRole } from '@styluxinc/api-schema';
import { ReactNode } from 'react';
import { ROUTES } from '.';

export type NavigationItem = {
  name?: string;
  component?: ReactNode;
  href?: string;
  onClick?: () => void;
  icon?: ReactNode;
  /**
   * Nav item is visible to users with any of the roles
   */
  roles?: IApiRole[] | null;
};

// TODO: add user navigation
export const userNavigation: NavigationItem[] = [
  {
    name: 'Settings',
    href: ROUTES.merchants,
    icon: <Cog6ToothIcon />,
  },
  {
    name: 'Alerts',
    href: '',
    icon: <BellIcon />,
  },
];

export const mainNavigation: NavigationItem[] = [
  {
    name: 'Dashboard',
    href: ROUTES.dashboard,
    roles: [],
  },
  {
    name: 'Orders',
    href: ROUTES.orders,

    roles: RESOURCE_TO_ROLE_MAP.ORDERS,
  },
  {
    name: 'B2B Orders',
    href: ROUTES.b2bOrders,

    // TODO: use RESOURCE_TO_ROLE_MAP.B2B_ORDERS once we have b2b orders data
    // this temporary hides it from the navbar
    // but can still access via URL if they have the role in RESOURCE_TO_ROLE_MAP.B2B_ORDERS
    roles: [],
  },
  {
    name: 'Inventory',
    href: ROUTES.inventory,

    roles: RESOURCE_TO_ROLE_MAP.INVENTORY,
  },
  {
    name: 'Offers',
    href: ROUTES.offers,

    roles: RESOURCE_TO_ROLE_MAP.OFFERS,
  },
  {
    name: 'Products',
    href: ROUTES.products,
    roles: [],
  },
];
